<template>
  <v-flex
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-row>
        <v-col
          cols="3"
        >
          <v-select
            :items="propagandists"
            item-text="fullname"
            item-value="id"
            v-model="filters.propagandist_id"
            :label="$t('fields.propagandist')"
            :error-messages="errors"
            clearable
          >
          </v-select>
        </v-col>

        <v-col
          cols="3"
        >
        <v-select
          :items="schools"
          item-text="full_text"
          item-value="school_id"
          v-model="filters.school_id"
          :label="$t('fields.school')"
          :error-messages="errors"
          clearable
        >
        </v-select>
        </v-col>
    </v-row>
    <v-card flat light>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="totalItems"
        :no-data-text="$t('NO_DATA')"
        :no-results-text="$t('NO_DATA')"
        hide-default-footer
        :options.sync="pagination"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:[`item.name`]="{ item }">
            {{ item.type.name}}
        </template>

        <template v-slot:[`item.schools_types_name`]="{ item }">
            {{ item.type.code}} {{ item.type.grouped}}
        </template>

        <template v-slot:[`item.is_primary`]="{ item }">
           <v-icon
            v-if="item.type.schools_types_options && item.type.schools_types_options.is_primary"
           >done
           </v-icon>
           <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_secondary`]="{ item }">
            <v-icon
              v-if="item.type.schools_types_options && item.type.schools_types_options.is_secondary"
            >done
            </v-icon><v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_elementary`]="{ item }">
            <v-icon
              v-if="item.type.schools_types_options
              && item.type.schools_types_options.is_elementary"
            >done
            </v-icon>
            <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.city`]="{ item }">
             {{ item.address.city || null}}
        </template>

        <template v-slot:[`item.province`]="{ item }">
             {{ item.address.province_code || null}}
        </template>

        <template v-slot:[`item.code`]="{ item }">
             <span
              v-for="location in item.school_locations_options"
              :key="location.branch_code"
            >
              {{ location.branch_code }}&nbsp;
            </span>
        </template>

      </v-data-table>
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchReport"
      />
    </v-card>
  </v-flex>
</template>
<script>

import { adoptionsService } from '../../../utils/services/adoptions.service';
import { propagandistsService } from '../../../utils/services/propagandists.service';
import { propagandistsSchoolsService } from '../../../utils/services/propagandistsSchools.service';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AdoptionReportPropagandistSchool',
  components: { Paginator },
  data() {
      return {
        loading: false,
        propagandists: [],
        schools: [],
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['name'],
        },
        headers: [
          { text: this.$t('fields.code'), value: 'code', sortable: false },
          { text: this.$t('fields.type'), value: 'schools_types_name' },
          { text: this.$t('fields.school'), value: 'name' },
          { text: this.$t('fields.city'), value: 'city', sortable: false },
          { text: this.$t('fields.province'), value: 'province', sortable: false },
          { text: this.$t('fields.is_elementary'), value: 'is_elementary', sortable: false },
          { text: this.$t('fields.is_primary'), value: 'is_primary', sortable: false },
          { text: this.$t('fields.is_secondary'), value: 'is_secondary', sortable: false },
          { text: this.$t('fields.is_new'), value: 'counter_new' },
          { text: this.$t('fields.is_suggested'), value: 'counter_suggested' },
          { text: this.$t('fields.capociclo'), value: 'counter_capociclo' },
        ],
        filters: {
          propagandist_id: null,
          school_id: null,
        },
      };
    },

    computed: {
      requestFilters() {
        const filters = {
          propagandistId: this.filters.propagandist_id,
          schoolId: this.filters.school_id,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },

    methods: {

      resetItems() {
        this.items = [];
        this.totalItems = 0;
        this.pagination.page = 1;
      },

      async fetchPropagandist() {
        return propagandistsService.index()
        .then(response => {
            this.propagandists = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchSchools() {
        this.schools = [];

        return propagandistsSchoolsService.index(this.filters.propagandist_id, {
          itemsPerPage: 1000,
          filters: { sortDesc: [true], sortBy: ['schools.name'] } },
        )
        .then(response => {
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchReport(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return adoptionsService.reportPropagandistSchool({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        },
          )
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
              this.handleError(error, this.errors);
          }).finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      await this.fetchPropagandist();
      this.fetchReport();
    },
    watch: {
      'filters.propagandist_id': {
        handler() {
          this.resetItems();
          this.fetchSchools();
          this.fetchReport(1);
        },
      },
      'filters.school_id': {
        handler() {
          this.resetItems();
          this.fetchReport(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchReport(1);
          }
        },
      },
    },
};
</script>
